// "1-3, 5" → the page numbers it references; `valid` is false on malformed tokens.
// Lifted from ParcelsTab's WypisPageMapModal so the extraction review modal shares
// the exact same validation of page specs.
export function parsePageSpec(spec: string): { pages: number[]; valid: boolean } {
  const pages: number[] = [];
  let valid = true;
  for (const part of spec.split(/[,;]/).map((s) => s.trim()).filter(Boolean)) {
    const range = part.match(/^(\d+)\s*[-–]\s*(\d+)$/);
    if (range) {
      const a = Number(range[1]);
      const b = Number(range[2]);
      if (a < 1 || a > b) valid = false;
      for (let i = a; i <= b; i++) pages.push(i);
    } else if (/^\d+$/.test(part)) {
      pages.push(Number(part));
    } else {
      valid = false;
    }
  }
  return { pages, valid };
}
